/**
 * CHARSTAN Platform Registry — Single source of truth for all shared
 * enums, statuses, style configs, labels, and UI constants.
 *
 * All pages/components must import from here. Do not redefine locally.
 */

// ==================== IDENTITY & ACCESS ====================

export const USER_ROLES = { ADMIN: "admin", AUDITOR: "auditor", CLIENT: "client", READER: "reader" };
export const INTERNAL_ROLES = new Set(["admin", "auditor"]);
export const EXTERNAL_ROLES = new Set(["client", "reader"]);

// ==================== CRM / ORGANIZATIONS ====================

export const ORG_STATUS_STYLES = {
  active:    { bg: "bg-emerald-500/10", text: "text-emerald-400", label: "Active" },
  onboarding:{ bg: "bg-blue-500/10",    text: "text-blue-400",    label: "Onboarding" },
  inactive:  { bg: "bg-gray-500/10",    text: "text-gray-400",    label: "Inactive" },
  suspended: { bg: "bg-red-500/10",     text: "text-red-400",     label: "Suspended" },
};

export const RISK_STYLES = {
  high:   { bg: "bg-red-500/10",     text: "text-red-400" },
  medium: { bg: "bg-amber-500/10",   text: "text-amber-400" },
  low:    { bg: "bg-emerald-500/10", text: "text-emerald-400" },
};

export const REGION_LABELS = {
  US: "United States", EU: "European Union", CA: "Canada", BR: "Brazil",
  LATAM: "Latin America", AU: "Australia", JP: "Japan", CN: "China",
  UK: "United Kingdom", OUS: "OUS / Global Other",
};

// ==================== SUPPORT TICKETS ====================

export const TICKET_STATUS_STYLES = {
  open:        { bg: "bg-blue-500/10",    text: "text-blue-400",    label: "Open" },
  in_progress: { bg: "bg-amber-500/10",   text: "text-amber-400",   label: "In Progress" },
  waiting:     { bg: "bg-purple-500/10",  text: "text-purple-400",  label: "Waiting" },
  resolved:    { bg: "bg-emerald-500/10", text: "text-emerald-400", label: "Resolved" },
  closed:      { bg: "bg-gray-500/10",    text: "text-gray-400",    label: "Closed" },
};

export const TICKET_PRIORITY_STYLES = {
  critical: { bg: "bg-red-500/10",    text: "text-red-400" },
  high:     { bg: "bg-orange-500/10", text: "text-orange-400" },
  medium:   { bg: "bg-amber-500/10",  text: "text-amber-400" },
  low:      { bg: "bg-gray-500/10",   text: "text-gray-400" },
};

export const TICKET_CATEGORY_LABELS = {
  onboarding: "Onboarding",
  audit: "Audit",
  governance: "Governance",
  technical: "Technical",
  general: "General",
};

// ==================== REGIONAL OBLIGATIONS ====================

export const ACTIVATION_STATUS_STYLES = {
  active:       { bg: "bg-emerald-500/10", text: "text-emerald-400", label: "Active" },
  under_review: { bg: "bg-amber-500/10",   text: "text-amber-400",   label: "Under Review" },
  suppressed:   { bg: "bg-gray-500/10",    text: "text-gray-400",    label: "Suppressed" },
  archived:     { bg: "bg-red-500/10",     text: "text-red-400",     label: "Archived" },
};

export const OBLIGATION_CATEGORY_CONFIG = {
  incident_notification: { color: "text-amber-400",   bg: "bg-amber-500/15",   label: "Incident Notification" },
  data_residency:        { color: "text-cyan-400",    bg: "bg-cyan-500/15",    label: "Data Residency" },
  privacy_security:      { color: "text-purple-400",  bg: "bg-purple-500/15",  label: "Privacy & Security" },
  record_integrity:      { color: "text-emerald-400", bg: "bg-emerald-500/15", label: "Record Integrity" },
  breach_reporting:      { color: "text-red-400",     bg: "bg-red-500/15",     label: "Breach Reporting" },
};

// ==================== ORG TYPE LABELS ====================

export const ORG_TYPE_LABELS = { client: "Client", provider: "Provider", internal: "Internal" };

// ==================== HEALTH SCORE ====================

export const getHealthColor = (score) => {
  if (score >= 70) return "#10B981";
  if (score >= 50) return "#EAB308";
  return "#EF4444";
};

export const getHealthLabel = (score) => {
  if (score >= 70) return "Healthy";
  if (score >= 50) return "Needs Attention";
  return "At Risk";
};
